import assets from "app/assets";
import config from "config";
import gsap from "gsap";
import { Container, DEG_TO_RAD, Text, Sprite, TextStyle } from "pixi.js";
import tools from "tools";
import Btn from "./btn";
export default class Popin extends Container {
  constructor(blackLayer, onShow, onHide) {
    super();
    this.build = this.build.bind(this);
    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);
    this.share = this.share.bind(this);
    this.invite = this.invite.bind(this);
    this.onCloseDown = this.onCloseDown.bind(this);
    this.onCloseUp = this.onCloseUp.bind(this);
    this.onCloseOut = this.onCloseOut.bind(this);
    this.onCtaUp = this.onCtaUp.bind(this);
    this.onTryUp = this.onTryUp.bind(this);
    this.tournamentProcess = this.tournamentProcess.bind(this);
    this.singleInterstitial = this.singleInterstitial.bind(this);
    this.requestInterstitial = this.requestInterstitial.bind(this);
    this.requestTournament = this.requestTournament.bind(this);
    this.interstitial = this.interstitial.bind(this);
    this._layer = blackLayer;
    this._onShow = onShow;
    this._onHide = onHide;
    this.build();
  }
  build() {
    this.bg = new Sprite(assets.textures.popinBg.texture);
    this.bg.scale.set(.7);
    this.bg.anchor.set(.5);
    this.addChild(this.bg);
    this.rv = new Sprite(assets.textures.rv.texture);
    // this.rv.scale.set(.6);
    this.rv.anchor.set(.5);
    this.rv.visible = false;
    // this.rv.position.set(0, -40);
    this.addChild(this.rv);
    this.inviteBtn = new Btn(assets.local.invite, 40, 0xffffff, 0x3C2FA1, assets.textures.friendsPicto.texture);
    this.inviteBtn.click = this.invite;
    this.inviteBtn.y = 90;
    this.addChild(this.inviteBtn);
    this.shareBtn = new Btn(assets.local.share, 40, 0xffffff, 0x0c7bd1, assets.textures.sharePicto.texture);
    this.shareBtn.click = this.share;
    this.shareBtn.y = 185;
    this.addChild(this.shareBtn);
    this.cta = new Btn(assets.local.free, 60, config.ctaTextColor, tools.hashtagToHexa(config.ctaColor));
    this.cta.click = this.onCtaUp;
    this.cta.position.set(0, 170);
    this.addChild(this.cta);
    this.try = new Btn(assets.local.tryagain, 60, config.tryTextColor, tools.hashtagToHexa(config.tryColor));
    this.try.click = this.onTryUp;
    this.try.position.set(0, 50);
    this.addChild(this.try);
    this.close = new Sprite(assets.textures.close.texture);
    this.close.position.set(this.bg.width * .45, -this.bg.height * .45);
    this.close.anchor.set(.5);
    this.close.interactive = true;
    this.close.buttonMode = true;
    this.close.on('pointerdown', this.onCloseDown);
    this.close.on('pointerup', this.onCloseUp);
    this.close.on('pointerupoutside', this.onCloseOut);
    this.addChild(this.close);
    const textStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 50,
      align: "center",
      fill: config.failTextColor,
      dropShadow: true,
      dropShadowAlpha: 1,
      dropShadowAngle: DEG_TO_RAD * 90,
      dropShadowBlur: 4,
      dropShadowColor: '0x000000',
      dropShadowDistance: 6,
      wordWrap: true,
      wordWrapWidth: 400
    });
    this.text = new Text(assets.local.nomoves, textStyle);
    this.text.anchor.set(.5);
    this.text.position.set(0, -150);
    this.addChild(this.text);
    this.bestScoreText = new Text("0");
    this.bestScoreText.style.fontSize = 35;
    this.bestScoreText.style.fill = 0xffffff;
    this.bestScoreText.style.fontFamily = 'Anja Eliane accent';
    this.bestScoreText.anchor.set(.5);
    this.bestScoreText.position.set(0, -102);
    this.addChild(this.bestScoreText);
    const currentScoreStyle = new TextStyle({
      fontFamily: 'Anja Eliane accent',
      fontSize: 40,
      align: "center",
      fill: 0xe8ce09,
      dropShadow: true,
      dropShadowAlpha: 1,
      dropShadowAngle: DEG_TO_RAD * 90,
      dropShadowBlur: 4,
      dropShadowColor: '0x000000',
      dropShadowDistance: 6
    });
    this.currentScoreLabel = new Text(assets.local.currentscore, currentScoreStyle);
    this.currentScoreLabel.anchor.set(.5);
    this.currentScoreLabel.position.set(0, -50);
    this.addChild(this.currentScoreLabel);
    this.currentScoreText = new Text("0");
    this.currentScoreText.style.fontSize = 35;
    this.currentScoreText.style.fill = 0xffffff;
    this.currentScoreText.style.fontFamily = 'Anja Eliane accent';
    this.currentScoreText.anchor.set(.5);
    this.currentScoreText.position.set(0, -10);
    this.addChild(this.currentScoreText);
    this.visible = false;
  }
  onCloseDown(event) {
    if (config.pause) {
      return;
    }
    if (!this._closeDown) {
      this._closeDown = true;
      gsap.to(this.close.scale, {
        duration: .2,
        x: .8,
        y: .8
      });
    }
  }
  onCloseUp(event) {
    if (config.pause) {
      return;
    }
    if (this._closeDown) {
      this.hide();
      if (this.leaderBoardsOpen) {
        this.tryProcess();
      } else {
        // this.tournamentProcess();

        this.currentScore = parseInt(config.currentScore * config.scoreCoef);
        config.sdk.getPlatform().notifyLevelEnd(0, this.currentScore, false);
        config.endSession = true;
        config.ui.visible = false;
        gsap.delayedCall(.5, () => {
          //config.boosterRvPopin.hide();

          //leaderboard callback
          //config.ui.showHomeMenu();
          this.interstitial();
        });
      }
    }
    this._closeDown = false;
  }
  onCloseOut(event) {
    if (config.pause) {
      return;
    }
    this._closeDown = false;
    gsap.to(this.close.scale, {
      duration: .2,
      x: 1,
      y: 1
    });
  }
  onCtaUp(event) {
    if (config.pause) {
      return;
    }

    //RV video

    this.requestRewarded(() => {
      this.requestRewardedOpen = true;
      config.sound && config.sound.pause();
      this.text.scale.set(1);
      this.text.text = assets.local.nomoves;
      this.try.text = assets.local.tryagain;

      // this.hideTween && this.hideTween.kill();
      // this.hideTween = gsap.delayedCall(.2, this.hide);

      this.hide();
    }, () => {
      config.ui.bonusMoveVal = config.bonus4;
      config.ui.resetMoves(config.bonus4, true);
      this.hide();
      if (config.noMoreMove) {
        config.level.resetAllBubbles();
      } else {
        config.level.lightEffect();
        gsap.delayedCall(1, () => {
          config.level.updateCoins(config.bonusCoins1);
        });
      }
      config.gameOver = false;
      config.noMoreMove = false;

      // config.ui.showHomeMenu();
    });
  }
  onTryUp(event) {
    if (config.pause) {
      return;
    }
    config.endSession = true;
    this.hide();
    config.ui.showHomeMenu();
    this.interstitial();
  }
  tournamentProcess() {
    this.currentScore = parseInt(config.currentScore * config.scoreCoef);
    this.requestTournament(() => {
      this.setScore(this.currentScore);
      config.level.onResize(window.innerWidth, window.innerHeight);
    }, () => {
      // Continue directement sans afficher le leaderboard (action play/continuer)

      config.sound && config.sound.pause();

      // Réinit niveau et réactiver les clics sur les bulles (comme closePopin du leaderboard)
      config.firstTime = true;
      config.gameOver = false;
      config.ui.bonusMoveVal = 1;
      config.ui.resetMoves(config.startMoves);
      config.ui.score = 0;
      config.level.resetAllBubbles();
      config.ui.playerBubble.explod();
      config.header.initPlayers();
      config.ui.saveScore(config.currentScore);
      config.ui.reseize();
      if (!config.noAds) {
        this.requestInterstitial(() => {
          config.sound && config.sound.pause();
        }, () => {
          config.ui.updateLevel(config.playerLevel);
        });
      } else {
        config.ui.updateLevel(config.playerLevel);
      }
    }, () => {});
    setTimeout(() => {
      config.ui.visible = true;
      config.ui.reseize();
    }, 1000);
  }
  interstitial() {
    config.playerLevel++;
    config.sdk.getStoreModule().save("level", {
      value: config.playerLevel
    });
    this.tournamentProcess();
  }

  // Called in game when player no move

  singleInterstitial() {
    if (config.noAds) {
      return;
    }

    /*this.requestRewardInterstitial(
        () => {
            config.app.pause(true);
            config.sound && config.sound.pause();
            config.hintDelayTween && config.hintDelayTween.kill();
        },
          () => {
            //change delay after first time
            config.interstitialDelay = config.interstitialDelay2;
              config.hintDelayTween && config.hintDelayTween.kill();
            config.hintDelayTween = gsap.delayedCall(config.hintDelay, config.level.hint);
              this.resumeAfterInterstitial();
        }
    );*/
  }
  async setScore(score) {
    config.sdk.getScoreModule().setBestScore(score);
  }
  async requestRewarded(onInit, callback) {
    onInit && onInit();
    const rewOk = true;
    this.requestRewardedOpen = false;
    if (rewOk) {
      callback && callback();
      config.firstTime = false;
      config.sound && config.sound.pause();
      config.level.launchInterstitialInterval();
      config.ui.showMovesPanel();
    } else {
      config.ui.showHomeMenu();
      this.currentScore = parseInt(config.currentScore * config.scoreCoef);
      config.sdk.getPlatform().notifyLevelEnd(0, this.currentScore, false);
      this.interstitial();
    }

    // config.sdk.getAnalyticsModule().onCustomEvent("inGame_onRVEnd", rewOk);
  }
  async requestInterstitial(onInit, callback) {
    onInit && onInit();
    callback && callback();
  }
  async requestRewardInterstitial(onInit, callback) {
    onInit && onInit();
    const riOk = false;
    // config.sdk.getAnalyticsModule().onCustomEvent("inGame_onRIEnd", riOk);

    if (riOk) {
      let bonus = tools.getRandomWithCoef(config.rewardBonnus, true);
      config.touchAccess = false;
      switch (bonus) {
        case "bomb":
          config.boosterPopin.show(assets.textures.bombBoost.texture, "x1", 300, 220, false, () => {
            config.boosterMenu.bombVal++;
            config.sdk.getStoreModule().save("bomb", {
              value: config.boosterMenu.bombVal
            });
          });
          break;
        case "rocket":
          config.boosterPopin.show(assets.textures.rocketBoost.texture, "x1", 300, 220, false, () => {
            config.boosterMenu.rocketVal++;
            config.sdk.getStoreModule().save("rocket", {
              value: config.boosterMenu.rocketVal
            });
          });
          break;
        case "swap":
          config.boosterPopin.show(assets.textures.swapBoost.texture, "x1", 300, 220, false, () => {
            config.boosterMenu.swapVal++;
            config.sdk.getStoreModule().save("swap", {
              value: config.boosterMenu.swapVal
            });
          });
          break;
        case "hammer":
          config.boosterPopin.show(assets.textures.hammerBoost.texture, "x1", 300, 220, false, () => {
            config.boosterMenu.hammerVal++;
            config.sdk.getStoreModule().save("hammer", {
              value: config.boosterMenu.hammerVal
            });
          });
          break;
        case "2moves":
          config.boosterPopin.show(null, "+2", 300, 220, false, () => {
            config.ui.movesText += 2;
          }, false, .65, true);
          break;
        case "4moves":
          config.boosterPopin.show(null, "+4", 300, 220, false, () => {
            config.ui.movesText += 4;
          }, false, .65, true);
          break;
        case "25coins":
          config.boosterPopin.show(assets.textures.coins2.texture, "+25", 300, 220, false, () => {
            config.level.updateCoins(25);
          }, false, 1.4);
          break;
        case "50coins":
          config.boosterPopin.show(assets.textures.coins3.texture, "+50", 300, 220, false, () => {
            config.level.updateCoins(50);
          }, false, .85);
          break;
        default:
          break;
      }
    }
    callback && callback();
  }

  //Called on booster popin

  async singleRequestRewarded(callback) {
    config.level.clearInterstitialDelay();
    this.requestRewardedOpen = true;
    config.app.pause(true);
    config.sound && config.sound.pause();
    callback && callback();

    this.requestRewardedOpen = false;
    this.resumeAfterInterstitial();
  }
  async requestTournament(onInit, callback, onErr) {
    onInit && onInit();
    callback && callback();
  }
  resumeAfterInterstitial() {
    config.app.pause(false);
    config.soundAccess && config.sound && config.sound.play();
    config.level.launchInterstitialInterval();
  }
  leaderBoards() {
    if (!this.visible) {
      this.show();
    }
    this.leaderBoardsOpen = true;
    this.text.text = assets.local.mybestcore;
    this.text.style.fill = 0xed7171;
    this.text.y = -140;
    this.currentScoreLabel.visible = true;
    this.currentScoreText.visible = true;
    this.bestScoreText.visible = true;
    this.bestScoreText.text = config.oldScore;
    this.currentScoreText.text = parseInt(config.currentScore * config.scoreCoef);
    this.inviteBtn.visible = false;
    this.shareBtn.visible = false;
    this.cta.visible = false;
    this.try.visible = false;
    this.rv.visible = false;
    if (config.sdk.getPlatform().getName() === "facebook" || config.sdk.getPlatform().getName() === "dev") {
      this.inviteBtn.visible = true;
      this.shareBtn.visible = true;
    }
  }
  invite() {
    if (config.pause) {
      return;
    }

    this.hide();
  }
  choose() {
    if (config.pause) {
      return;
    }
  }
  share() {
    if (config.pause) {
      return;
    }
  }
  tryProcess() {
    config.firstTime = true;
    config.gameOver = false;
    config.ui.bonusMoveVal = 1;
    config.ui.resetMoves(config.startMoves);
    config.ui.score = 0;
    this.hide();
    config.level.resetAllBubbles();
    config.ui.playerBubble.explod();

    // config.header.updateScore(0, 0);
    config.header.initPlayers();
    config.ui.saveScore(config.currentScore);

    // config.header.resetAllPlayers();
  }
  show() {
    this.leaderBoardsOpen = false;
    if (config.firstTime) {
      this.text.style.fill = config.failTextColor;
      this.text.text = assets.local.nomoves;
      this.try.text = assets.local.tryagain;
      this.currentScoreLabel.visible = false;
      this.currentScoreText.visible = false;
      this.bestScoreText.visible = false;
      this.rv.visible = true;
      this.cta.visible = true;
      this.try.visible = false;
      // config.firstTime = false;
      this.inviteBtn.visible = false;
      this.shareBtn.visible = false;
      this.text.y = -140;
    } else {
      this.text.y = -100;
      this.try.visible = true;
      this.cta.visible = false;
    }
    this.showDelayPopTween && this.showDelayPopTween.kill();

    // if (!this.visible) {
    this.showDelayPopTween = gsap.delayedCall(1, () => {
      this._layer.visible = true;
      config.level.addChildAt(this._layer, 2);
      this._onShow && this._onShow();
      this.close.visible = true;
      this.scale.set(.3);
      this.visible = true;
      gsap.to(this.scale, {
        duration: .5,
        x: 1,
        y: 1,
        ease: "back.out(2)"
      });
    });
    // }

    config.level.clearInterstitialDelay();
  }
  hide() {
    this._layer.visible = false;
    config.level.removeChild(this._layer);
    this.close.visible = false;
    this._onHide && this._onHide();
    gsap.to(this.scale, {
      duration: .2,
      x: .3,
      y: .3,
      onComplete: () => {
        this.visible = false;
        this.cta.visible = false;
        this.rv.visible = false;
        this.try.visible = false;
      }
    });
    config.app.pause(false);
    config.soundAccess && !this.requestRewardedOpen && config.sound && config.sound.play();
    config.level.onResize(window.innerWidth, window.innerHeight);
    if (config.endSession) {
      config.level.launchInterstitialInterval();
      config.endSession = false;
    }
  }
}
